module.exports = __webpack_public_path__ + "869a3051e0aefae10ab6293ced71c9e7.png";